import { api } from './baseApi';
export var tabletsApi = api.injectEndpoints({
    endpoints: function (builder) {
        return ({
            getTabletsWithSearch: builder.query({
                query: function (_a) {
                    var page = _a.page, limit = _a.limit, search = _a.search, restId = _a.restId;
                    return ({
                        url: "/tablets/searchWithPagination",
                        method: 'GET',
                        params: { restId: restId, page: page, limit: limit, search: search },
                    });
                },
                providesTags: ['Tablets'],
            }),
            getTablets: builder.query({
                query: function (params) {
                    return ({
                        url: "/tablets/".concat(params.restaurantId),
                        method: 'GET',
                        // params: {params.restaurantId},
                        // credentials: 'include',
                        // params: params,
                    });
                },
                providesTags: ['Tablets'],
            }),
            createTablets: builder.mutation({
                query: function (body) {
                    return ({
                        method: 'POST',
                        url: "/tablets",
                        body: body,
                    });
                },
                invalidatesTags: ['Tablets'],
            }),
            editTablets: builder.mutation({
                query: function (_a) {
                    var body = _a.body, id = _a.id;
                    return ({
                        method: 'PATCH',
                        url: "/tablets/".concat(id),
                        body: body,
                    });
                },
                invalidatesTags: ['Tablets'],
            }),
            deleteTablet: builder.mutation({
                query: function (_a) {
                    var tabletId = _a.tabletId;
                    return ({
                        method: 'DELETE',
                        url: "/tablets/".concat(tabletId),
                        params: { tabletId: tabletId },
                    });
                },
                invalidatesTags: ['Tablets'],
            }),
        });
    },
});
export var useLazyGetTabletsQuery = tabletsApi.useLazyGetTabletsQuery, useGetTabletsQuery = tabletsApi.useGetTabletsQuery, useGetTabletsWithSearchQuery = tabletsApi.useGetTabletsWithSearchQuery, useCreateTabletsMutation = tabletsApi.useCreateTabletsMutation, useDeleteTabletMutation = tabletsApi.useDeleteTabletMutation, useEditTabletsMutation = tabletsApi.useEditTabletsMutation;
